__turbopack_context__.v({
  "markdownFeed": "markdown-module__FdXuhG__markdownFeed",
  "wmde-markdown": "markdown-module__FdXuhG__wmde-markdown",
  "wmdeMarkdown": "markdown-module__FdXuhG__wmdeMarkdown",
});
